import ConversationList from '@pages/ChatFeed/LeftColumn/ConversationList';
import type { FC } from 'react';
import { memo, useCallback, useEffect, useState } from 'react';

import { useBoundStore } from '@/newstore';
import { useActiveConversation } from '@/newstore/selectors/shared';

import styles from './LeftColumn.module.scss';
import SearchInput from './SearchInput';

interface StateProps {
  isConversationsListLoaded: boolean;
}

const NonMemoLeftColumn: FC<StateProps> = ({ isConversationsListLoaded }) => {
  // TODO: extract state to higher order component
  const { conversation: activeConversation } = useActiveConversation();
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    setSearchQuery('');
  }, [activeConversation]);

  const handleSearchQuery = useCallback((query: string) => {
    setSearchQuery(query);
  }, []);

  return (
    <div id="left-column">
      <div className={styles.root}>
        <SearchInput onChange={handleSearchQuery} value={searchQuery} />
        {isConversationsListLoaded && <ConversationList searchQuery={searchQuery} />}
      </div>
    </div>
  );
};

export default memo(function LeftColumn() {
  // TODO: load conversations anyways (when they're optimized), just don't show them
  const isLeftColumnShown = useBoundStore((state) => state.isLeftColumnShown);

  return <NonMemoLeftColumn isConversationsListLoaded={isLeftColumnShown} />;
});
